<template>
    <q-btn
        v-bind="{...$attrs, ...$props}"
        no-caps
        class="next_button2"
    />
</template>

<script>
export default {
    name: 'NextButton2',
};
</script>

<style scoped lang="scss">
    .next_button2 {
        border: 1px solid var(--main-purple-border-1);
        border-radius: 12px;
        height: 44px;
        color: var(--main-text);
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        line-height: 24px;
    }
</style>
